import firebase from "firebase";

export const uploadImageReturnUrl = async (imageAsFile: Blob, path: string) => {
  const fileName = randomId() + "." + getExtensionFile(imageAsFile.type);
  const pathImage = `${await path}${await fileName}`;
  const storage = firebase.storage().ref(pathImage);
  await storage.put(imageAsFile);
  //initiates the firebase side uploading
  const url = await storage.getDownloadURL().then((fireBaseUrl: string) => {
    return fireBaseUrl;
  });
  return url;
};

const randomId = function () {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return (
    Math.random().toString(36).substr(2, 30) +
    Math.random().toString(36).substr(2, 30)
  );
};
const getExtensionFile = (type: string) =>
  type.split("/")[type.split("/").length - 1];
